import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';
import Group from '../list/group';
import GroupAge from '../list/group-age';
import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';

const API_PATH = 'event-groups';
const API_PATH_AGES = 'event-group-ages';
const API_PATH_GLOBAL = 'global-event-groups';

export const GroupManager = {
  objects: {
    ...objectsRHandler(API_PATH, Group),
    nominationAttach({ args = [], data } = DEFAULT_PARAMS) { // { groups: Number[] }
      const [nomination_id] = args;
      return rHandler(
        apiService.put(`/event-nominations/${nomination_id}/groups`, data),
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
    nominationDetach({ args = [], data } = DEFAULT_PARAMS) { // { groups: Number[] }
      const [nomination_id] = args;
      return rHandler(
        apiService.delete(`/event-nominations/${nomination_id}/groups`, data),
        (response) => ({ response }),
        (error) => ({ error }),
      );
    },
  },
  ages: objectsRHandler(API_PATH_AGES, GroupAge),
  global: {
    index({ params, obs } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.getCached(API_PATH_GLOBAL, params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new Group(i, API_PATH_GLOBAL)),
        }),
        (error) => ({ error }),
        obs,
      );
    },
  },
};
